import React from 'react';
import '../Scenario1/Scenario1.css';
import Scenario4Header from '../../img/Scenario4Header.jpg';
import Scenario4Video from './Scenario4Video';
import Scenario4Two from './Scenario4Two';
import Scenario4Video2 from './Scenario4Video2';
import Scenario4Four from './Scenario4Four';
import Scenario4Video3 from './Scenario4Video3';
import Scenario4Five from './Scenario4Five';
import Scenario4Video4 from './Scenario4Video4';
import Scenario4Six from './Scenario4Six';
import Scenario4Video5 from './Scenario4Video5';
import NavBar from '../Navbar';
import { NavLink } from 'react-router-dom';


const Scenario4 = () => {
    return (
        <div>
            <NavBar />
            <div className='contentLeftPadding'>
                <div className='container contentWrapper'>
                    <div className='Scenario2Wrapper'>
                        <div className='Scenario2Img'>
                            <img src={Scenario4Header} alt='logo' />
                        </div>
                        <div className='Scenario2Content'>
                            <div className='lessonNumber'>10 сабақтың 5-шісі</div>
                            <h1>Адам құқығы, Сценарий 4</h1>
                            <div className='homeAnons'>
                                <h2>Тыңшы</h2>
                                <p>Күдікті браконьер арнайы күзетілетін табиғи аймақта қадағаланып, қамауға алынды. Ол ешқандай браконьерлік құрал-саймандарды
                            алып жүрмейді, бірақ инспекторлардың іздері 4-6 адамнан тұратын топты көрсетеді.</p>
                            </div>
                        </div>
                    </div>
                    <Scenario4Video />
                    <Scenario4Two />
                    <Scenario4Video2 />
                    <Scenario4Four />
                    <Scenario4Video3 />
                    <Scenario4Five />
                    <Scenario4Video4 />
                    <Scenario4Six />
                    <Scenario4Video5 />
                    <button className='btnNext'><NavLink to='/Scenario5'>Ары қарай</NavLink></button>
                </div>
            </div>
        </div>
    );
}

export default Scenario4;